// @ts-nocheck
import {
    getCurrentUserIsGuest,
    getIsPunchOutSession,
    getSession,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import convertSelectorToHook from "@store/Framework/Common/Utilities/convertSelectorToHook";
import { getCurrentLanguage, getWebsite } from "@store/Framework/Store/Context/ContextSelectors";

export const useSettingsCollection = convertSelectorToHook(getSettingsCollection);
export const useWebsite = convertSelectorToHook(getWebsite);
export const useCurrentLanguage = convertSelectorToHook(getCurrentLanguage);
export const useIsPunchOutSession = convertSelectorToHook(getIsPunchOutSession);
export const useSession = convertSelectorToHook(getSession);
export const useCurrentUserIsGuest = convertSelectorToHook(getCurrentUserIsGuest);
